import type { CityConfig } from "../city-template/types";

export const catonsvilleConfig: CityConfig = {
  city: "Catonsville",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "catonsville",
  route: "/cities/catonsville",
  title: "Emergency Passport Catonsville, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Catonsville, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Catonsville, Arbutus, Woodlawn, and Ellicott City residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Catonsville, MD",
  heroSubtitle: "Catonsville travelers — from UMBC students to Baltimore County families to commuters — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Baltimore County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Charming%20view%20of%20Catonsville%20Maryland%20historic%20downtown%20along%20Frederick%20Road%20with%20vintage%20brick%20buildings%2C%20tree-lined%20streets%2C%20quaint%20local%20shops%2C%20American%20flags%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20suburban%20photography%2C%20no%20visible%20text%20or%20people%2C%20clean%20architectural%20details%20and%20green%20landscaping%2C%20Baltimore%20County%20atmosphere&width=1800&height=700&seq=catonsville-hero-001&orientation=landscape",
  heroImageAlt: "View of Catonsville Maryland historic downtown along Frederick Road with charming brick buildings",
  geoPosition: "39.2721;-76.7319",
  geoPlacename: "Catonsville, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 45–55 minutes from Catonsville via I-95 S",
  },
  nearbyCitiesZips: [
    { name: "Catonsville", zips: "21228, 21229, 21250" },
    { name: "Arbutus", zips: "21227" },
    { name: "Woodlawn", zips: "21207, 21244" },
    { name: "Ellicott City", zips: "21041, 21042, 21043, 21045" },
    { name: "Halethorpe", zips: "21227" },
    { name: "Lansdowne", zips: "21227" },
    { name: "Windsor Mill", zips: "21244" },
    { name: "Randallstown", zips: "21133" },
    { name: "Dundalk", zips: "21222" },
    { name: "Essex", zips: "21221" },
    { name: "Middle River", zips: "21220" },
    { name: "Rosedale", zips: "21237" },
    { name: "Baltimore", zips: "21201, 21202, 21205, 21206, 21209, 21210, 21211, 21212, 21213, 21214, 21215, 21216, 21217, 21218, 21222, 21223, 21224, 21225, 21226, 21227, 21228, 21229, 21230, 21231, 21234, 21236, 21237, 21239, 21251" },
    { name: "Towson", zips: "21204, 21252, 21284, 21285, 21286" },
    { name: "Columbia", zips: "21044, 21045, 21046" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Catonsville and Baltimore County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-community-line", title: "Baltimore County Hub", desc: "Serving UMBC students, families, and Baltimore commuters" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Baltimore, MD", route: "/cities/baltimore" },
    { name: "Emergency passport help in Ellicott City, MD", route: "/cities/ellicott-city" },
    { name: "Urgent passport services in Towson, MD", route: "/cities/towson" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Catonsville, Maryland remotely via secure registered courier. We do not have a walk-in office in Catonsville — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Catonsville and Baltimore County travelers without the drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Catonsville, Arbutus, Woodlawn, Ellicott City, and greater Baltimore County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Catonsville area and greater Baltimore County. From the historic Catonsville downtown along Frederick Road to the UMBC campus, from the residential neighborhoods of Arbutus and Woodlawn to the nearby communities of Ellicott City and Halethorpe — we serve all of Baltimore County's diverse communities.",
  nearbyCitiesIntro: "We serve Catonsville and nearby communities including Arbutus, Woodlawn, Ellicott City, Halethorpe, Lansdowne, Windsor Mill, Randallstown, Dundalk, Essex, Middle River, and Rosedale. We also serve Baltimore, Towson, and Columbia residents who prefer our expedited service.",
  howItWorksIntro: "Most Catonsville travelers complete everything online and ship documents overnight. No need to drive 45–55 minutes to downtown DC or navigate Baltimore Beltway traffic.",
  mistakesIntro: "Catonsville is a major Baltimore County hub with a mix of university students, commuting professionals, and families. Here are the most common passport mistakes we see from Catonsville travelers.",
  testimonialsIntro: "Catonsville travelers — from UMBC students to Baltimore commuters to county families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Catonsville, MD? Here are the most common ones we hear from Baltimore County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request certified marriage records from the Baltimore County Circuit Court Clerk. Required for name change passport applications.", url: "https://www.baltimorecountymd.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Baltimore County Circuit Court. Required for name change passport corrections.", url: "https://www.baltimorecountymd.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for study abroad and family travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 45–55 min to downtown DC", "Full day commitment — challenging for working commuters"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Catonsville travelers with immediate departure needs — as fast as 24 hours. Perfect for study abroad, family emergencies, and last-minute business trips.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Study abroad and commuter travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Catonsville adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Catonsville address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Catonsville residents and families — including UMBC students and international visitors.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Catonsville residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Catonsville families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Catonsville residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Catonsville MD", description: "Urgent passport processing for Catonsville Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Catonsville MD", description: "Fast passport renewal for Catonsville Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Catonsville MD", description: "New passport application services for Catonsville Maryland residents applying for their first passport." },
    { name: "Child Passport Catonsville MD", description: "Minor passport services for Catonsville Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jessica T.",
      location: "UMBC, Catonsville",
      rating: 5,
      text: "Study abroad program in Spain with 10 days notice. Fast Passport Center reviewed every document, caught a photo issue, and delivered my passport in 48 hours. Saved my semester abroad.",
      service: "Emergency Passport",
    },
    {
      name: "Michael R.",
      location: "Arbutus, MD",
      rating: 5,
      text: "Family cruise to the Caribbean with 8 days notice. Four passports processed in under a week. The agent handled everything — we just shipped the documents from the Catonsville UPS Store.",
      service: "Family Passport Bundle",
    },
    {
      name: "Amanda K.",
      location: "Woodlawn, MD",
      rating: 5,
      text: "Business trip to London with 6 days notice. Fast Passport Center had my renewed passport ready in 36 hours. No need to drive to DC — everything shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "David L.",
      location: "Ellicott City, MD",
      rating: 5,
      text: "Lost my passport before a family trip to Mexico. They walked me through the replacement process and had it in my hands in 48 hours. Professional service that understands family travel urgency.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "catonsville-1",
      name: "Catonsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1501 Frederick Rd",
      city: "Catonsville",
      state: "MD",
      zip: "21228",
      phone: "(410) 744-5158",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Catonsville, on Frederick Road",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Catonsville acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient access from I-695 and I-70.",
      icon: "ri-mail-line",
    },
    {
      id: "catonsville-2",
      name: "Arbutus Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5401 East Dr",
      city: "Baltimore",
      state: "MD",
      zip: "21227",
      phone: "(410) 242-6341",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Arbutus, approximately 2 miles south of Catonsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Arbutus and Halethorpe residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "catonsville-3",
      name: "Woodlawn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1810 Woodlawn Dr",
      city: "Gwynn Oak",
      state: "MD",
      zip: "21207",
      phone: "(410) 298-9254",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Woodlawn, approximately 3 miles north of Catonsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Woodlawn and Windsor Mill residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "catonsville-4",
      name: "Ellicott City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3375 Court House Dr",
      city: "Ellicott City",
      state: "MD",
      zip: "21043",
      phone: "(410) 465-2800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ellicott City, approximately 4 miles west of Catonsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Howard County and western Baltimore County residents. Good alternative when Catonsville appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "catonsville-5",
      name: "Baltimore County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "111 W Chesapeake Ave",
      city: "Towson",
      state: "MD",
      zip: "21204",
      phone: "(410) 887-2600",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Towson, approximately 8 miles northeast of Catonsville",
      website: "https://www.baltimorecountymd.gov/",
      websiteLabel: "Baltimore County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via I-695.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 45–55 min drive to downtown DC", fpc: "No — ship from Catonsville" },
    { feature: "Study Abroad Support", agency: "No flexibility for university needs", fpc: "Yes — we handle student and academic cases" },
    { feature: "UMBC Student & Faculty Travel", agency: "No campus travel coordination", fpc: "Yes — UMBC academic travel specialists" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Baltimore County Commuter", agency: "No commuter-friendly scheduling", fpc: "Yes — remote service for busy commuters" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Catonsville's busy students and commuters often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Catonsville sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Catonsville and Baltimore County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Catonsville Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Catonsville residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Catonsville, Arbutus, or Woodlawn." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near downtown Catonsville or along Route 40." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Catonsville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Catonsville, MD?", a: "Fast Passport Center offers emergency passport processing in Catonsville, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (45–55 minutes from Catonsville) — without you needing to make the drive or fight Baltimore Beltway traffic." },
    { q: "Does Catonsville have its own passport agency?", a: "No — neither Catonsville nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 45–55 minutes from Catonsville via I-95 S. Fast Passport Center's courier service means Catonsville residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Arbutus or Woodlawn?", a: "Absolutely. Fast Passport Center serves all of the Catonsville area including Arbutus, Woodlawn, Ellicott City, Halethorpe, and Lansdowne. We also serve Dundalk, Essex, Middle River, and Rosedale residents. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Catonsville, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Catonsville travelers use for international flights?", a: "Most Catonsville residents fly internationally through Baltimore-Washington International (BWI), approximately 20–25 minutes east via I-195. Dulles International (IAD) is 55–65 minutes southwest via I-695 and I-270. Reagan National (DCA) is 50–60 minutes south via I-95. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Catonsville?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Catonsville, Arbutus, Woodlawn, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Catonsville?", a: "The Catonsville Post Office at 1501 Frederick Rd is the primary downtown acceptance facility. The Arbutus Post Office at 5401 East Dr serves southern Baltimore County. The Woodlawn Post Office at 1810 Woodlawn Dr serves northern Catonsville. The Ellicott City Post Office at 3375 Court House Dr serves western Howard County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Catonsville residents should plan ahead, especially for study abroad programs and family vacations." },
  ],
  photoLocations: [
    { name: "Walgreens — Catonsville", address: "6440 Baltimore National Pike, Catonsville, MD 21228", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Catonsville", address: "1 Frederick Rd, Catonsville, MD 21228", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "UPS Store — Catonsville", address: "700 S Rolling Rd, Catonsville, MD 21228", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://locations.theupsstore.com/md/catonsville" },
    { name: "FedEx Office — Woodlawn", address: "6420 Security Blvd, Gwynn Oak, MD 21207", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://local.fedex.com/en-us/md/gwynn-oak" },
  ],
  dmvLocations: [
    { name: "MVA — Glen Burnie", address: "6601 Ritchie Hwy NE, Glen Burnie, MD 21062", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Anne Arundel and Baltimore County. REAL ID processing available.", featured: true },
    { name: "MVA — Columbia", address: "6490 Dobbin Center Way, Columbia, MD 21045", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Howard County and western Baltimore County. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "20–25 minutes from Catonsville via I-195 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary international departure airport for Catonsville travelers. Direct flights to London, Cancun, and major European hubs. Southwest Airlines hub.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "50–60 minutes from Catonsville via I-95 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Secondary option for domestic connections to international hubs. Major business travel airport.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "55–65 minutes from Catonsville via I-695 W and I-270 W",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for international flights and United Airlines hub connections.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};